import i18n from "../i18n.js";

function unknownError() {
  return i18n.t("proxy.withdrawals.errors.unknown", {
    defaultValue: "Unknown error, please try again later.",
  });
}

function translatedError(errorKey) {
  if (!errorKey) return unknownError();

  return i18n.t(errorKey, {
    defaultValue: unknownError(),
  });
}

function withProxyQuery(path) {
  const search = typeof window !== "undefined" ? window.location.search || "" : "";
  const normalized = path.startsWith("/") ? path : `/${path}`;

  return `${normalized}${search}`;
}

export async function proxyFetch(path, options = {}) {
  const { json, headers, ...rest } = options;
  const init = {
    ...rest,
    headers: {
      Accept: "application/json",
      "X-Requested-With": "XMLHttpRequest",
      ...(json !== undefined ? { "Content-Type": "application/json" } : {}),
      ...headers,
    },
  };

  if (json !== undefined) {
    init.body = JSON.stringify(json);
  }

  const res = await fetch(withProxyQuery(path), init);
  const text = await res.text();
  let data;
  try {
    data = text ? JSON.parse(text) : {};
  } catch {
    data = { ok: false, error_key: "proxy.withdrawals.errors.unknown", status: res.status };
  }

  if (data.error_key && !data.error) {
    data.error = translatedError(data.error_key);
  }

  if (!res.ok && !data.error && !data.error_key) {
    data = {
      ok: false,
      error_key: "proxy.withdrawals.errors.unknown",
      error: unknownError(),
      status: res.status,
    };
  }

  return { res, data };
}
